// The receipts views inside Finance: "What we bought", "All receipts" and one
// receipt, as a stack. Each list view's filters live in its stack entry, so
// Back from a receipt returns to the same list with the same filters.
import { useState } from 'react';
import WhatWeBought from './WhatWeBought';
import AllReceipts from './AllReceipts';
import ReceiptScreen from './ReceiptScreen';
import { defaultBrowse } from './browseModel';

const BACK = { dash: 'What we bought', all: 'All receipts', receipt: 'Receipt' };

export default function ReceiptsView({ start, onExit, groceriesCategoryId }) {
  // { kind: 'dash', filterKind?, state? } | { kind: 'all', state } | { kind: 'receipt', id }
  const [stack, setStack] = useState([start.kind === 'all' ? { kind: 'all', state: defaultBrowse(start.state || {}) } : start]);
  const top = stack[stack.length - 1];
  const below = stack.length > 1 ? stack[stack.length - 2] : null;
  const backLabel = below ? BACK[below.kind] : 'Finance';
  const push = (v) => setStack((s) => [...s, v]);
  const back = () => (stack.length > 1 ? setStack((s) => s.slice(0, -1)) : onExit());
  const setTopState = (state) => setStack((s) => [...s.slice(0, -1), { ...s[s.length - 1], state }]);
  const openReceipt = (id) => push({ kind: 'receipt', id });

  if (top.kind === 'receipt') {
    return <ReceiptScreen key={top.id} id={top.id} backLabel={backLabel} onBack={back} onOpenKind={(k) => push({ kind: 'dash', filterKind: k })} />;
  }
  if (top.kind === 'all') {
    return <AllReceipts state={top.state} onState={setTopState} onOpenReceipt={openReceipt} onBack={back} backLabel={backLabel} />;
  }
  return (
    <WhatWeBought
      key={`dash-${stack.length}-${top.filterKind || ''}`}
      initialKind={top.filterKind || null}
      groceriesCategoryId={groceriesCategoryId}
      backLabel={backLabel}
      state={top.state || null}
      onState={setTopState}
      onBack={back}
      onOpenReceipt={openReceipt}
      onOpenAll={(over) => push({ kind: 'all', state: defaultBrowse(over) })}
    />
  );
}
